import { DateValidation } from "./DateValidation";

export class DateRange {
  public feedbackMessage = "";
  private left: DateValidation;
  private right: DateValidation;

  public get valid(): boolean {
    this.validate();
    return this.feedbackMessage === "";
  }

  constructor(left: DateValidation, right: DateValidation) {
    this.left = left;
    this.right = right;
  }

  public clear(): void {
    this.feedbackMessage = "";
  }

  private validate(): void {
    if (!this.left.valid || !this.right.valid) {
      this.feedbackMessage = "";
      return;
    }
    if (this.left.moment === null || this.right.moment === null) {
      this.feedbackMessage = "";
      return;
    }

    if (this.right.moment.isBefore(this.left.moment)) {
      this.feedbackMessage = "To date cannot be earlier than from date";
      return;
    }
    this.feedbackMessage = "";
  }
}
